import axios from "axios";
import { BACKEND_URL } from "./config";


export interface IGetPurchaseResponse {
  amount_total: number;
  createdAt: string;
  id: number;
  payment_status: string;
  quantity: number;
  session: string;
  years: number;
}

export const get = async (id:string, jwt: string): Promise<IGetPurchaseResponse> => {
  try {
    const response = await axios.request({
      method: "get",
      url: `${BACKEND_URL}/purchases/${id}`,
      headers: {
        Authorization: "Bearer " + jwt,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const getAll = async (jwt: string): Promise<IGetPurchaseResponse[]> => {
  try {
    const response = await axios.request({
      method: "get",
      url: `${BACKEND_URL}/purchases/`,
      headers: {
        Authorization: "Bearer " + jwt,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

